import { pbVaultDocuments } from './adapters/pb-vault-documents'
import type { VaultDocumentPort } from './domain/document'

const vaultDocuments: VaultDocumentPort = pbVaultDocuments

export { vaultDocuments }
